module.exports = __webpack_public_path__ + "static/media/far2con.0fcbe6b0.png";